<div class="chat-page">
  <div class="container clearfix t-widget">
    <div class="chat">
      <div class="chat-history" id="chatHistory-{{ contact.contactId }}">
        <loader *ngIf="!contact.messages || chatLoading"></loader>

        <ul>
          <li *ngFor="let msg of contact.messages" class="clearfix">
            <div *ngIf="msg.unreadDividerSw" class="unread-divider">
              {{ "translate.chat.unreadMsgs" | translate }}
            </div>

            <div
              *ngIf="!msg.unreadDividerSw"
              class="chat-message-container"
              [class.other]="!msg.isMine"
              [class.my]="msg.isMine"
            >
              <div
                class="msg-with-delete-container"
                [class.other]="!msg.isMine"
                [class.my]="msg.isMine"
              >
                <div
                  class="message"
                  [class.other]="!msg.isMine"
                  [class.my]="msg.isMine"
                  [class.unread]="!msg.isMine && !msg.readByMe"
                  [class.chat-bubble]="!msg.isMine"
                  [class.is-file]="msg.file"
                  [class.is-ltr]="forceLtr"
                  [class.audio]="msg.contentType == 'AUDIO'"
                  (click)="onMsgClicked(msg)"
                >
                  <div
                    *ngIf="!msg.file && !msg.contentUrl"
                    class="message-text"
                  >
                    <markdown
                      [data]="msg.msgText"
                      [dir]="getTextDirection(msg.msgText)"
                      markdownLinks
                    ></markdown>
                  </div>

                  <audio
                    *ngIf="msg.contentType == 'AUDIO'"
                    controls
                    style="height: 35px"
                  >
                    <source [src]="msg.audioSrc" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- [url]="msg.audioSrc" -->

                  <div
                    *ngIf="msg.file"
                    class="file-container"
                    (click)="openFile(msg)"
                  >
                    <ng-container
                      [ngSwitch]="
                        msg.file.fileType == 'pdf'
                          ? 1
                          : msg.file.fileType == 'html'
                          ? 2
                          : msg.file.isVideo
                          ? 3
                          : -1
                      "
                    >
                      <ng-container *ngSwitchCase="1">
                        <div class="file-icon-preview">
                          <img src="assets\img\PDF_Files.svg" />
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="2">
                        <div class="file-icon-preview">
                          <ng-container *ngIf="!msg.modelType">
                            <img
                              *ngIf="msg.isMine"
                              src="assets\img\3D_Scan_new.svg"
                            />
                            <img
                              *ngIf="!msg.isMine"
                              src="assets\img\3D_Scan_white.svg"
                            />
                          </ng-container>
                          <ng-container *ngIf="msg.modelType == 'IMPRINT'">
                            <img
                              *ngIf="msg.isMine"
                              src="assets\img\3D_scanner_icon.svg"
                            />
                            <img
                              *ngIf="!msg.isMine"
                              src="assets\img\3D_scanner_icon_white.svg"
                            />
                          </ng-container>
                          <ng-container *ngIf="msg.modelType == 'DESIGN'">
                            <img
                              *ngIf="msg.isMine"
                              src="assets\img\3D_cast_icon.svg"
                            />
                            <img
                              *ngIf="!msg.isMine"
                              src="assets\img\3D_cast_icon_white.svg"
                            />
                          </ng-container>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="3">
                        <div class="file-icon-preview">
                          <img
                            *ngIf="msg.isMine"
                            src="assets\img\VideoFile.svg"
                          />
                          <img
                            *ngIf="!msg.isMine"
                            src="assets\img\VideoFile_Inverse.svg"
                          />
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="file-img-preview">
                          <img [src]="msg.file.url" />
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>

                <a *ngIf="displayChatTasks && msg.taskId">
                  <img class="icon-flag" src="assets\img\Flag.svg" />
                </a>

                <a
                  *ngIf="
                    allowDeleteMsg && displayMsgActionsBtn && msg == curMsg
                  "
                  (click)="deleteMsg(msg)"
                >
                  <img class="icon-action" src="assets\img\Delete.svg"
                /></a>
                <a
                  *ngIf="
                    displayChatTasks &&
                    !msg.taskId &&
                    displayMsgActionsBtn &&
                    msg == curMsg
                  "
                  (click)="createTask(msg)"
                >
                  <img class="icon-action" src="assets\img\Flag_Circle.svg"
                /></a>
              </div>

              <div
                class="message-data"
                [class.other]="!msg.isMine"
                [class.my]="msg.isMine"
              >
                <img
                  *ngIf="displayReadStatus && msgReadByTarget(msg)"
                  (click)="curMsg = msg; displayReadStatusPopup = true"
                  class="icon-read-status"
                  src="assets\img\check-all.svg
              "
                />
                <img
                  *ngIf="displayReadStatus && !msgReadByTarget(msg)"
                  (click)="curMsg = msg; displayReadStatusPopup = true"
                  class="icon-read-status"
                  src="assets\img\check-all-grey.svg
            "
                />

                <span
                  >{{ msg.fromUserDescr }} /
                  {{ msg.timestamp | date : "HH:mm - dd.MM.yyyy" }}</span
                >
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- [class.is-ltr]="forceLtr" -->
      <div class="input-message" [class.disabled]="disabled">
        <button
          class="btn-emoji"
          id="emoji-trigger_{{ contact.contactId }}"
          (click)="emojiPanel.toggle($event)"
        >
          <i class="far fa-smile"></i>
        </button>

        <textarea
          dir="auto"
          id="txt_{{ contact.contactId }}"
          name="message-to-send"
          rows="1"
          [(ngModel)]="newMsg.msgText"
          [disabled]="sending"
          (keypress)="onKeyPress($event)"
          (paste)="onPaste($event)"
          pTextarea
          [autoResize]="true"
        ></textarea>

        <!-- [placeholder]="newMsgPlaceholder" -->

        <!-- pInputTextarea
        [autoResize]="true" -->

        <button
          class="t-button--rounded"
          (click)="sendMsg()"
          [disabled]="sending || !newMsg.msgText"
        >
          <img class="icon-send-msg" src="assets\img\Send_Message.svg" />
        </button>
      </div>
    </div>
  </div>
</div>

<p-popover #emojiPanel [dismissable]="true" appendTo="body">
  <emoji-mart
    (emojiClick)="addEmoji($event, emojiPanel)"
    emoji="point_up"
    [showPreview]="false"
  ></emoji-mart>
</p-popover>

<modal-popup
  *ngIf="displayReadStatusPopup && curMsg"
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayReadStatusPopup = false"
  [isOpen]="displayReadStatusPopup"
>
  <msg-read-status
    [msg]="curMsg"
    (onClose)="displayReadStatusPopup = false"
  ></msg-read-status>
</modal-popup>
